import { render, staticRenderFns } from "./SectionHeart.vue?vue&type=template&id=7158563a&scoped=true&"
import script from "./SectionHeart.vue?vue&type=script&lang=js&"
export * from "./SectionHeart.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeart.vue?vue&type=style&index=0&id=7158563a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158563a",
  null
  
)

export default component.exports